import { ChatStatus, DashboardSettingsFilters, UserTicketStatus } from "../../../__generated__/api";
import { tryParseDate } from "../../../date";
import TicketItem from "../ticket-item";
import { FILTER_REGISTRY, Filter } from "./base";

export default class UnreadFilter extends Filter {
    public static shouldCreate(filter: DashboardSettingsFilters): boolean {
        return filter.userTicketStatus?.isNotEmpty ?? false;
    }

    private statuses: Set<UserTicketStatus>;

    public constructor(filter: DashboardSettingsFilters) {
        super(filter);
        this.statuses = new Set(filter.userTicketStatus ?? []);
    }

    public shouldInclude(ticket: TicketItem): boolean {
        let shouldInclude = true;

        if (this.statuses.has(UserTicketStatus.Unread)) {
            shouldInclude = ticket.isUnread;
        } else if (this.statuses.has(UserTicketStatus.Read)) {
            shouldInclude = !ticket.isUnread;
        }

        if (!shouldInclude) {
            return false;
        }

        const lastAgentMessageDate = ticket.lastAgentResponseDate?.getTime() ?? 0;
        const lastUserMessageDate = ticket.lastUserMessageDate?.getTime() ?? 0;

        if (this.statuses.has(UserTicketStatus.LastMessageFromAgent)) {
            shouldInclude = lastAgentMessageDate > lastUserMessageDate;
        } else if (this.statuses.has(UserTicketStatus.LastMessageFromUser)) {
            shouldInclude = lastAgentMessageDate < lastUserMessageDate;
        }

        if (this.statuses.has(UserTicketStatus.UnassignedOrMine)) {
            shouldInclude = shouldInclude && (
                ticket.chat.assignee == null
                || ticket.chat.isCurrentUserParticipating === true
                || ticket.chat.isAssignedToCurrentUser === true
            );
        }

        if (!shouldInclude) {
            return false;
        }

        if (this.statuses.has(UserTicketStatus.SlaUpcoming)
            || this.statuses.has(UserTicketStatus.SlaExpired)
            || this.statuses.has(UserTicketStatus.SlaUpcomingSoon)) {
            const now = Date.now();
            return ticket.ticket.dueDates?.some(dueDate => {
                if (dueDate.completedDate) {
                    return false;
                }

                const due = tryParseDate(dueDate.dueDate)?.getTime() ?? Number.MAX_SAFE_INTEGER;
                if ((due > now && this.statuses.has(UserTicketStatus.SlaUpcoming))
                    || (due < now && this.statuses.has(UserTicketStatus.SlaExpired))) {
                    return true;
                }
                if (now > due && this.statuses.has(UserTicketStatus.SlaUpcomingSoon)) {
                    const totalDuration = due - (tryParseDate(dueDate.startedDate)?.getTime() ?? 0);
                    const percentLeft = (now - due) / totalDuration;
                    return percentLeft < 0.1;
                }

                return false;
            }) ?? false;
        }

        return shouldInclude;
    }
}

FILTER_REGISTRY.register(UnreadFilter);
